import { Injectable } from '@angular/core';
import { Apollo, gql, MutationResult } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { ApolloError, ApolloQueryResult, InMemoryCache } from '@apollo/client/core';
import { catchError } from 'rxjs/operators';
import { BehaviorSubject, Observable, Subject, Subscription, throwError } from 'rxjs';
import { LocalStorageService } from '../../shared/storage/local-storage.service';
import { environment } from '../../../environments/environment';
import { io } from 'socket.io-client';
import { frontEndBaseUrl } from '../../shared/frontEndBaseUrl';
import { RouteInfo } from '../../shared/vertical-menu/vertical-menu.metadata';
import { PULSERIGHT_ROUTES } from '../../shared/vertical-menu/vertical-pulseright-menu-routes.config';

@Injectable({
  providedIn: 'root'
})
export class GraphQlService {
  uri = environment.apiBaseUrl;
  public userData: any = {
    auth: {},
    organizationGroupList: [],
    doctorList: [],
    SelectedOrg: '',
    SelectedOrgGrp: '',
    patientList: [],
    moduleNames: [],
    StaffList: [],
    serviceList: [],
    dashboard: {},
    managerDashboard: {},
    timeOffList: [],
    overTime: [],
  };
  menuLoader = new BehaviorSubject<string>('OrgDetails');
  private menus$ = new BehaviorSubject<any[]>([]);  // ✅ holds menu list
  menusObs$ = this.menus$.asObservable();          // components subscribe here
  refreshDoctorsList = new Subject<string>();
  booking_socket: any;
  queue_socket: any;
  queue_socket_remove: any;
  adds_socket: any;
  queueUpdateNamespace: any;
  scrollingMessageNamespace: any;
  public socketEndpoint = `${environment.apiBaseUrl}`;
  private menus: RouteInfo[] = [];

  constructor(private apollo: Apollo, httpLink: HttpLink, private storage: LocalStorageService) {
    this.apollo.create({
      link: httpLink.create({ uri: this.uri + '/graphql' }), // Replace with your API URL
      cache: new InMemoryCache()
    });
    this.booking_socket = io(`${this.socketEndpoint}/booking`);
    this.queue_socket = io(`${this.socketEndpoint}/queue`);
    this.queue_socket_remove = io(`${this.socketEndpoint}/queueRemove`);
    this.adds_socket = io(`${this.socketEndpoint}/campaign`);
    this.queueUpdateNamespace = io(`${this.socketEndpoint}/queueUpdate`);
    this.scrollingMessageNamespace = io(`${this.socketEndpoint}/doctors`);
  }

  emitEvent(eventName: string, data: string) {
    this.booking_socket.emit(eventName, data);
  }


  async setMenusByAllowedList(userType: string, moduleName: string[]) {
    const menus = JSON.parse(JSON.stringify(PULSERIGHT_ROUTES));
    const result2 = ['Admin', 'Pharmacy Admin'].includes(userType) ? menus : menus.filter((r) => moduleName.includes(r.title.trim()));
    const role = userType;
    const menuData = result2.filter(item => item.category.includes(role)).map(item => {
      if (item.submenu && item.submenu.length > 0) {
        const filteredSubmenu = item.submenu.filter(sub => sub.category.includes(role)).map(sub => {
          if (sub.submenu && sub.submenu.length > 0) {
            sub.submenu = sub.submenu.filter(subsub => subsub.category.includes(role));
          }
          return sub;
        });
        item.submenu = filteredSubmenu.length ? filteredSubmenu : item.submenu;
      }
      return item;
    });
    this.menus$.next(menuData);
    return Promise.resolve();
  }

  async loadMenus(ROUTES, userType: string) {
    const role = userType;
    const menuData = ROUTES.filter(item => item.category.includes(role)).map(item => {
      if (item.submenu && item.submenu.length > 0) {
        const filteredSubmenu = item.submenu.filter(sub => sub.category.includes(role)).map(sub => {
          if (sub.submenu && sub.submenu.length > 0) {
            sub.submenu = sub.submenu.filter(subsub => subsub.category.includes(role));
          }
          return sub;
        });
        item.submenu = filteredSubmenu.length ? filteredSubmenu : item.submenu;
      }
      return item;
    });
    return menuData;
  }

  getMenus() {
    return this.menus$.getValue(); // get current menus instantly
  }

  // emit queue Removal
  queue_emit_removeQueue(eventName: string, data: string) {
    this.queue_socket_remove.emit(eventName, data);
  }


  // emit queue position update for socket

  queue_emit_position(eventName: string, data: string) {
    this.queueUpdateNamespace.emit(eventName, data);
  }


  // emit doctor availability message

  doctor_availability_message(eventName: string, data: string) {
    this.scrollingMessageNamespace.emit(eventName, data);
  }


  // websocket Integration to perform auto refresh Queue System
  onQueuePush(): Observable<any> {
    return new Observable((observer: any) => {
      this.queue_socket?.on('message', (data) => {
        observer.next(data);
      });
    });
  }


  // Observing  queue removals
  onQueuePop(): Observable<any> {
    return new Observable((observer: any) => {
      this.queue_socket_remove?.on('message', (data: any[]) => {
        observer.next(data);
      });
    });
  }


  OnQueue_position_update(): Observable<any> {
    return new Observable((observer: any) => {
      this.queueUpdateNamespace?.on('message', (data: any[]) => {
        observer.next(data);
      });
    });
  }

  chech_doctor_availability_message(): Observable<any> {
    return new Observable((observer: any) => {
      this.scrollingMessageNamespace?.on('message', (data: any[]) => {
        observer.next(data);
      });
    });
  }

  PongqueueRemove() {
    return new Observable((observer: any) => {
      this.queue_socket_remove?.on('pong', (data: any[]) => {
        observer.next(data);
      });
    });
  }

  PongqueueAdd() {
    return new Observable((observer: any) => {
      this.queue_socket?.on('pong', (data: any[]) => {
        observer.next(data);
      });
    });
  }

  PongqueueUpdateNamespace() {
    return new Observable((observer: any) => {
      this.queueUpdateNamespace?.on('pong', (data: any[]) => {
        observer.next(data);
      });
    });
  }

  PongMessage() {
    return new Observable((observer: any) => {
      this.scrollingMessageNamespace?.on('pong', (data: any[]) => {
        observer.next(data);
      });
    });
  }

  onSlotBooked(): Observable<any> {
    return new Observable((observer: any) => {
      this.booking_socket?.on('message', (data) => {
        observer.next(data);
      });
    });
  }

  queue_emit_Event(eventName: string, data: string) {
    this.queue_socket.emit(eventName, data);
  }

  // load organizationGroup by URL
  loadOrganizationGroupURL(QUERY: any) {
    const input = {
      url: frontEndBaseUrl
    }
    return this.apollo.watchQuery({
      query: QUERY,
      variables: { input },
      context: {
        headers: {
          'Content-type': 'application/json'
        }
      }
    }).valueChanges.pipe(catchError(err => throwError(err)));
  }


  // sign by email and password
  async login_Email(email: string, password: string, QUERY: any) {
    return await this.apollo.mutate({
      mutation: QUERY,
      variables: { email, password },
      context: {
        headers: { 'Content-type': 'application/json' }
      }
    }).toPromise().then(async (response: MutationResult | any) => {

      const user = response.data.loginEmail.user;
      const organization = response.data.loginEmail.organization;
      this.userData.auth = {
        token: response.data.loginEmail.token,
        refreshToken: response.data.loginEmail.refreshToken,
        data: {
          ...user, organization
        }
      };
      if (response.data.loginEmail.user.role === 'Super Admin') {
        await this.SelectedOrgGrpId(JSON.parse(localStorage.getItem('organizationGroup')).data._id, this.userData.auth.data.organization[0]._id);
        await this.getSelectedOrgId(JSON.parse(localStorage.getItem('organizationGroup')).data.organization[0]._id);
        await this.storage.saveData('pulse-right', JSON.stringify(this.userData));
      } else {
        const activeOrg = response.data.loginEmail.organization;
        await this.SelectedOrgGrpId(JSON.parse(localStorage.getItem('organizationGroup')).data._id, activeOrg[0]._id);
        await this.storage.saveData('pulse-right', JSON.stringify(this.userData));
      }
      this.menuLoader.next('OrgDetails');
      return this.userData;
    }).catch((err: ApolloError) => {
      return err.graphQLErrors;
    });
  }

  // login using phone number
  async login_Phone(number: string, kiosk: boolean, QUERY: any) {
    return await this.apollo.mutate({
      mutation: QUERY,
      variables: { number, kiosk },
      context: {
        headers: { 'Content-type': 'application/json' }
      }
    }).toPromise()
      .then((response: any) => {
        return response.data.loginPhone;
      })
      .catch((err: ApolloError) => {
        return err.graphQLErrors;
      });
  }

  // verify login OTP
  async verifyOtpForLoginPhone(number: string, otp: string, QUERY: any) {
    return this.apollo.mutate({
      mutation: QUERY,
      variables: { number, otp },
      context: {
        headers: { 'Content-type': 'application/json' }
      }
    })
      .toPromise()
      .then((response: any) => {
        return response.data.verifyOtpForLoginPhone;
      })
      .catch((err: ApolloError) => {
        throw err;
      });
  }

  login_email(email: string, password: string, QUERY: any) {
    return this.apollo.mutate<MutationResult>({
      mutation: QUERY,
      variables: { email, password },
      context: {
        headers: {
          'Content-type': 'application/json',
        }
      },
    }).pipe(catchError((err: ApolloError) => throwError(err.networkError)));
  }


  // fetch organization  id from localStorage
  async getSelectedOrgId(orgId) {
    this.userData.SelectedOrg = orgId;
    await this.storage.saveData('pulse-right', JSON.stringify(this.userData));
  }

  // storing the default organizationGroup Id
  async SelectedOrgGrpId(grpId, orgId) {
    this.userData.SelectedOrgGrp = grpId;
    this.userData.SelectedOrg = orgId;
    await this.storage.saveData('pulse-right', JSON.stringify(this.userData));
  }

  // fetch organization details by id
  async fetch_organization_Id(QUERY, user: any, orgId: string): Promise<any> {
    try {
      const response = await this.apollo.query({
        query: QUERY,
        variables: { orgId },
        fetchPolicy: 'network-only',
        context: {
          headers: {
            'Content-type': 'application/json',
            'Authorization': 'Bearer ' + user.auth.token + ''
          }
        }
      }).toPromise();
      if (response.errors && response.errors.length > 0) {
        throw new Error(response.errors[0].message);
      }

      return response;
    } catch (error) {
      throw error;
    }
  }

  // fetch all organizationGroups

  async fetchAllOrganizationGroups(user, QUERY, input): Promise<any> {
    return await this.apollo.query({
      query: QUERY,
      variables: input,
      fetchPolicy: 'network-only',
      context: {
        headers: {
          'Content-type': 'application/json',
          'Authorization': 'Bearer ' + user.auth.token + ''
        }
      }
    }).toPromise().then((response: ApolloQueryResult<any> | any) => {
      return response;
    }).catch((err: ApolloError) => {
      return { message: err.message };
    })
  }

  // fetch organization Group by Id

  async fetchOrgGrpById(user, QUERY, organizationGroupId: string): Promise<any> {
    return await this.apollo.query({
      query: QUERY,
      variables: { organizationGroupId },
      fetchPolicy: 'network-only',
      context: {
        headers: {
          'Content-type': 'application/json',
          'Authorization': 'Bearer ' + user.auth.token + ''
        }
      }
    }).toPromise().then((response: ApolloQueryResult<any> | any) => {
      return response;
    }).catch((err: ApolloError | any) => {
      return { message: err.message };
    })
  }


  // dependent register
  async dependent_register(user, QUERY: any, input: any) {
    return await this.apollo.mutate<any>({
      mutation: QUERY,
      variables: { input },
      context: {
        headers: {
          'Content-type': 'application/json',
          'Authorization': 'Bearer ' + user.auth.token
        }
      }
    }).toPromise().then((response: MutationResult) => {
      return response;
    }).catch((error: ApolloError) => {
      return error.networkError;
    });
  }

  // register organization

  async register_organizationGRP(user, QUERY: any, input: any) {
    return await this.apollo.mutate<any>({
      mutation: QUERY,
      variables: { input },
      context: {
        headers: {
          'Content-type': 'application/json',
          'Authorization': 'Bearer ' + user.auth.token
        }
      }
    }).toPromise().then((response: MutationResult) => {
      return response;
    }).catch((error: ApolloError) => {
      return error.networkError;
    });
  }

  // update organization group details

  async update_organization_group_details(user: any, QUERY: any, organizationGroupId: string, updates: any[]) {
    const input = { organizationGroupId, updates }
    return await this.apollo.mutate<any>({
      mutation: QUERY,
      variables: { input },
      context: {
        headers: {
          'Content-type': 'application/json',
          'Authorization': 'Bearer ' + user.auth.token
        }
      }
    }).toPromise().then((response: MutationResult) => {
      return response;
    }).catch((error: ApolloError) => {
      return error.networkError;
    });
  }

  // register organization
  async register_organization(user, QUERY: any, input: any) {
    return await this.apollo.mutate<any>({
      mutation: QUERY,
      variables: { input },
      context: {
        headers: {
          'Content-type': 'application/json',
          'Authorization': 'Bearer ' + user.auth.token
        }
      }
    }).toPromise().then((response: MutationResult) => {
      return response;
    }).catch((error: ApolloError) => {
      return error.networkError;
    });
  }


  // fetch Doctor Details
  async getQueryData(user, QUERY, input) {
    return await this.apollo.query<any>({
      query: QUERY,
      variables: input,
      fetchPolicy: 'network-only',
      context: {
        headers: {
          'Content-type': 'application/json',
          'Authorization': 'Bearer ' + user.auth.token
        }
      }
    }).toPromise().then((response: ApolloQueryResult<any> | any) => {
      return response;
    }).catch((error: ApolloError) => {
      return error.networkError;
    });
  }

  // fetch Organization Details
  async getQueryOrganizationData(user, QUERY, input) {
    try {
      const response = await this.apollo.query<any>({
        query: QUERY,
        variables: input,
        fetchPolicy: 'network-only',
        context: {
          headers: {
            'Content-type': 'application/json',
            'Authorization': 'Bearer ' + user.auth.token
          }
        }
      }).toPromise();

      return response; // { data, errors }
    } catch (error: ApolloError | any) {
      return {
        data: null,
        errors: error.graphQLErrors || [{ message: error.message || 'Unknown error' }]
      };
    }
  }


  // update organization details
  async update_organization_details(user: any, QUERY: any, input: any) {
    return await this.apollo.mutate<any>({
      mutation: QUERY,
      variables: { input },
      context: {
        headers: {
          'Content-type': 'application/json',
          'Authorization': 'Bearer ' + user.auth.token
        }
      }
    }).toPromise().then((response: MutationResult) => {
      return response;
    }).catch((error: ApolloError) => {
      return error.networkError;
    });
  }

  // fetch query result GET
  executeQuery(user, QUERY, input) {

    let headers: any = { 'Content-type': 'application/json' };
    if (user) {
      headers = { ...headers, ['Authorization']: 'Bearer ' + user.auth.token + '' };
    }
    return this.apollo.watchQuery<ApolloQueryResult<any> | any>({
      query: QUERY,
      variables: input,
      fetchPolicy: 'network-only',
      context: {
        headers
      },
    }).valueChanges.pipe(catchError((err: ApolloError) => throwError(err.networkError)));
  }

  // execute mutate query POST PATCH DELETE

  executeMutateQuery(user, QUERY, input) {
    let headers: any = { 'Content-type': 'application/json' };
    if (user) {
      headers = { ...headers, ['Content-type']: 'application/json', ['Authorization']: 'Bearer ' + user.auth.token + '' };
    }

    return this.apollo.mutate<MutationResult>({
      mutation: QUERY,
      variables: input,
      context: {
        headers
      },
    }).pipe(catchError((err: ApolloError) => throwError(err.networkError)));
  }

  executeCacheQuery(user: any, QUERY: any, input: any = {}, options: { fetchPolicy?: 'cache-first' | 'network-only' | 'no-cache' } = { fetchPolicy: 'cache-first' }) {
    try {
      let headers: any = { 'Content-type': 'application/json' };
      if (user) {
        headers = { ...headers, ['Authorization']: 'Bearer ' + user.auth.token + '' };
      }
      const apolloOptions: any = {
        query: QUERY,
        variables: input,
        fetchPolicy: options.fetchPolicy || 'cache-first',
        context: {
          headers
        }
      };
      return this.apollo.query(apolloOptions).pipe(catchError((err: ApolloError) => throwError(err.networkError)));
    } catch (err) {
      return throwError(err);
    }
  }
}
